/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * Final classification after applying Sanity optimal rules and Junction interpretation
 */
export type BiomarkerClassification = typeof BiomarkerClassification[keyof typeof BiomarkerClassification];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BiomarkerClassification = {
  pending: 'pending',
  no_results: 'no_results',
  optimal: 'optimal',
  normal: 'normal',
  out_of_range: 'out_of_range',
  critical: 'critical',
} as const;
